'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import { userSubscribe } from '../../modules/userSubscribe';
const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    gallery_modal_title: 'Galeria de imagens',
    gallery_modal_text: 'Não foram adicionadas imagens nessa ação.',
    materials_modal_title: 'Materiais adicionais',
    materials_modal_text: 'Não foram adicionados materiais nessa ação.',
  },
  en: {
    gallery_modal_title: 'Image gallery',
    gallery_modal_text: 'No images have been added to this action.',
    materials_modal_title: 'Additional Materials',
    materials_modal_text: 'No materials have been added to this action.',
  },
  es: {
    gallery_modal_title: 'Galería de imágenes',
    gallery_modal_text: 'No se añadieron imágenes en esta acción.',
    materials_modal_title: 'Materiales adicionales',
    materials_modal_text: 'No se añadieron materiales an esta acción.',
  },
};

const show = {
  init() {
    userSubscribe();

    if ($('.js-share-open').length) {
      document.getElementById('share-btn').click();
    }

    $('.js-additional-check').on('change', function (e) {
      if ($('#' + $(this).attr('data-id')).hasClass('u-display--none')) $('#' + $(this).attr('data-id')).removeClass('u-display--none');
      else {
        $('#' + $(this).attr('data-id')).addClass('u-display--none');
        $('#' + $(this).attr('data-id'))
          .find('input:text')
          .val('');
      }
    });

    $('.js-copy').on('click', function (e) {
      e.preventDefault();

      var range, selection, worked;
      var element = document.getElementById('challenge-link');

      if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      try {
        document.execCommand('copy');
        alert('Link copiado');
      } catch (err) {
        alert('unable to copy text');
      }
    });

    $('.js-modal-gallery').on('click', function () {
      Swal.fire({
        html: `<h3 class="o-ttl u-m-b-20">${tr[lang].gallery_modal_title}</h2><p>${tr[lang].gallery_modal_text}</p>`,
        padding: '25px 15px',
        position: 'top',
        showConfirmButton: false,
        showClass: {
          popup: 'c-new-swal--popup',
        },
        customClass: 'c-new-swal',
      });
    });

    $('.js-modal-materials').on('click', function () {
      Swal.fire({
        html: `<h3 class="o-ttl u-m-b-20">${tr[lang].materials_modal_title}</h2><p>${tr[lang].materials_modal_text}</p>`,
        padding: '25px 15px',
        position: 'top',
        showConfirmButton: false,
        showClass: {
          popup: 'c-new-swal--popup',
        },
        customClass: 'c-new-swal',
      });
    });
  },
};

export default show;
